<template>
  <v-app>
    <Loader 
    :appVersion="$appGlobals.appVersion" 
    :loadingInfo="loadingInfo">
    </Loader>    
    <v-navigation-drawer v-model="drawer" app clipped >
    </v-navigation-drawer>   
    <v-main>
      <template v-if="continueLoad">
      <Map 
        @updateLoadingInfo="updateLoadingInfo"
        :msal="msalService"
        :basemapCopyright="basemapCopyright"
        :basemaps="basemaps"
        :networks="networks"
        :layerUrl= "layerUrl"
        :primaryCatchmentService="primaryCatchmentService"
        :juniorCatchmentService="juniorCatchmentService"
        :secondaryCatchmentService="secondaryCatchmentService"
      /> 
      <Copyright :basemaps="basemaps" :basemapCopyright="basemapCopyright"></Copyright>
      </template>      
    </v-main>
     <v-footer :inset="footer.inset" app>   
    </v-footer>
  </v-app>
</template>

<script>
import Loader from "./components/Loader.vue";
import Map from './components/Map.vue';
import Copyright from './components/Copyright.vue';
import MsalService from './components/msal.js';
import MSGraphService from './components/msgraph.js'
let arcGISVersion = "4.24";     // Arcgis JS version
import { setDefaultOptions, loadCss, loadModules } from "esri-loader";
import axios from 'axios';
loadCss(`https://js.arcgis.com/${arcGISVersion}/esri/css/main.css`);

export default {
  name: 'App',
  components: {
    Loader,
    Map,
    Copyright
  },
  data: () => ({
    continueLoad: false,
    basemapCopyright:"© Norfolk County Council 2024\n© Crown Copyright and Database rights 2024 Ordnance Survey 100019340",
    loadingInfo:"",
    drawer: false,
    msalService: null,
    graphUser: null,
    basemaps:[
      {
          id: "basemap0",
          title: "Ordnance Survey Vector",
          url: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/basemaps/os_vector/MapServer",
          visible:true,
          copyright: `© Crown Copyright and Database rights ${new Date().getFullYear()} Ordnance Survey AC0000851272`,
      },
      {
          id: "basemap1",
          title: "Ordnance Survey Vector Blue",
          url: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/basemaps/os_vector_blue/MapServer",
          visible:false,
          copyright: `© Crown Copyright and Database rights ${new Date().getFullYear()} Ordnance Survey AC0000851272`,
      },
      {
          id: "basemap2",
          title: "Aerial Photography",
          url: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/basemaps/apgb_aerialphotography/MapServer",
          visible:false,
          copyright: `© Getmapping Plc and Bluesky International Limited ${new Date().getFullYear()}`,
      },

    ],
    layerUrl: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/apps/RoutesToSchools/MapServer",
    primaryCatchmentService: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/apps/RoutesToSchools/MapServer/1",
    juniorCatchmentService: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/apps/RoutesToSchools/MapServer/3",
    secondaryCatchmentService: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/apps/RoutesToSchools/MapServer/5",
    networks:[

    // even newer newer routing services.
    
      /*{ id: "roadsAndPaths", text: 'Roads and Paths', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_ncc_multimodal_pro_250116/NAServer/Route" },
      { id: "roads", text: 'Road Only', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_os_highways_network_pro_250116/NAServer/Route" },*/

      { id: "roadsAndPaths", text: 'Roads and Paths', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_ncc_multimodal_pro_241127/NAServer/Route" },
      { id: "roads", text: 'Road Only', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_os_highways_network_pro_241127/NAServer/Route" },

      // even newer routing services.
    
/*      { id: "roadsAndPaths", text: 'Roads and Paths', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_ncc_multimodal_pro_240712/NAServer/Route" },
      { id: "roads", text: 'Road Only', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_os_highways_network_pro_240712/NAServer/Route" },


      // New azure routing services

      { id: "roadsAndPaths", text: 'Roads and Paths', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_ncc_multimodal_pro/NAServer/Route" },
      { id: "roads", text: 'Road Only', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_os_highways_network_pro/NAServer/Route" },*/

      //{ id: "roads", text: 'Road Only', value: import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/networks/ntwk_os_highways_network_no_restr_pro/NAServer/Route" },

      // old routing services.

      //{ text: 'Roads and Paths', value: "https://giswebadaptor.norfolk.gov.uk/arcgis/rest/services/network_analysis/ncc_rts/NAServer/Route"},
      //{ text: 'Road Only', value: "https://giswebadaptor.norfolk.gov.uk/arcgis/rest/services/network_analysis/os_itn_rri/NAServer/Route"},
    ],
    footer: {
        inset: false,
    },
  }),
  async created () {

      setDefaultOptions({ 
        version: arcGISVersion, 
      });    

      //this.$vuetify.theme.dark = true
      this.loadingInfo = "Initialising ..." 
      this.msalService = new MsalService(import.meta.env.VITE_MSAL_ClientId, import.meta.env.VITE_MSAL_Authority);
      if(!this.msalService.isAuthenticated()){
        this.loadingInfo = "Whomst?!";
        console.log("signing in");
        this.msalService.signIn();        
        console.log("post sign in");
      } else {      
        console.log("init");
        await this.init();        
      }
    },
  methods:{
    async init() {
      //init MS Graph and get user details.
      const graphService = new MSGraphService(this.msalService);
      this.graphUser = await graphService.getUser();       
      this.loadingInfo = `Hey ${this.graphUser.displayName}`                                
      await this.initArcGISProxyAuthentication();  
      this.continueLoad = true;      
    },

    async initArcGISProxyAuthentication() {
      
      let arcGISConfig = (await loadModules(["esri/config"]))[0];                

      arcGISConfig.request.interceptors.push({
        before: async (params) => {      

          if (params.url.startsWith(import.meta.env.VITE_ARCGIS_URL)) {
            var accessToken = await this.msalService.getToken({scopes: [import.meta.env.VITE_MBAPI_AppIDURI]})          
            if (!params.requestOptions.headers) {
              params.requestOptions.headers = {};
            }
            
            params.requestOptions.headers.Authorization = "Bearer " + accessToken;      
          }                
        }
      })      
    },

    updateLoadingInfo(message){
      this.loadingInfo = message; 
    } 
  }
};
</script>
<style >

#App {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

html{
  overflow: hidden;
  /* padding: 0;
  margin: 0;
  height: 100%;
  width: 100%; */
}
/* *::-webkit-scrollbar {
    background-color:#424242;
    width:12px
}
*::-webkit-scrollbar-track {
    background-color:#424242
}
*::-webkit-scrollbar-track:hover {
    background-color:#424242
}
*::-webkit-scrollbar-thumb {
    background-color:#727272;
    border-radius:16px;
    border:3px solid #424242
}
*::-webkit-scrollbar-thumb:hover {
    background-color:#a0a0a5;
    border:3px solid #424242;
}
*::-webkit-scrollbar-button {display:none} */





div.esri-view-root > div.esri-view-surface > canvas{
  
  background: #333;
  background-image: linear-gradient(rgba(91, 92, 91, 0.3) .1em, transparent .1em), linear-gradient(90deg, rgba(91, 92, 91, 0.3) .1em, transparent .1em);
  background-size: 1em 1em;

}
.mapCopyright {
    white-space: pre !important;
    padding: 2px 8px;
    position: absolute;
    bottom: 12px;
    right: 14px;
    color: white;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 0.7rem;
    color:white;
    white-space: nowrap; 
    text-shadow:
    -1px -1px 0 rgba(30, 30, 30, 0.8),
    1px -1px 0 rgba(30, 30, 30, 0.8),
    -1px 1px 0 rgba(30, 30, 30, 0.8),
    1px 1px 0 rgba(30, 30, 30, 0.8);

}

.v-expansion-panel-content__wrap{
  padding: 4px 8px;
}
</style>
